import React, { useEffect, useState } from 'react';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';

const WHATSAPP_URL = 'https://wa.me/971508401805';

const FloatingActions: React.FC = () => {
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 200);
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="fixed bottom-5 right-4 z-40 flex flex-col items-end gap-3 md:bottom-8 md:right-8">
      {/* WhatsApp button */}
      <div className="relative group">
        <button
          type="button"
          onClick={() => window.open(WHATSAPP_URL, '_blank', 'noopener,noreferrer')}
          className="flex h-12 w-12 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg transition hover:bg-[#1eb656] md:h-13 md:w-13"
          aria-label="Chat on WhatsApp"
        >
          <WhatsAppIcon style={{ fontSize: 22 }} />
        </button>
        <div className="pointer-events-none absolute right-full top-1/2 mr-2 -translate-y-1/2 whitespace-nowrap rounded-full bg-black/80 px-3 py-1 text-xs text-white opacity-0 shadow-lg transition group-hover:opacity-100">
          Chat on WhatsApp
        </div>
      </div>

      {/* Back to top button */}
      {showScrollTop && (
        <button
          type="button"
          onClick={scrollToTop}
          className="flex h-10 w-10 items-center justify-center rounded-full bg-black/80 text-white shadow-lg transition hover:bg-black md:h-11 md:w-11"
          aria-label="Back to top"
        >
          <ArrowUpwardIcon style={{ fontSize: 20 }} />
        </button>
      )}
    </div>
  );
};

export default FloatingActions;
